import { render, staticRenderFns } from "./Builder.vue?vue&type=template&id=3f1e2143&scoped=true&"
import script from "./builder.js?vue&type=script&lang=js&"
export * from "./builder.js?vue&type=script&lang=js&"
import style0 from "./builder.scss?vue&type=style&index=0&id=3f1e2143&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1e2143",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f1e2143')) {
      api.createRecord('3f1e2143', component.options)
    } else {
      api.reload('3f1e2143', component.options)
    }
    module.hot.accept("./Builder.vue?vue&type=template&id=3f1e2143&scoped=true&", function () {
      api.rerender('3f1e2143', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/AudienceManager/Components/Builder/Builder.vue"
export default component.exports